/* Pooja Ragenee theme: pr-page.js = info pages (sections pr-page + pr-contact). Presentation only: the page text is never changed.
   - hides empty pasted paragraphs/divs, wraps tables for sideways scroll
   - [data-pr-headings]: short title-like lines in pasted content (no real headings) get heading styling (class + role=heading)
   - [data-pr-faq]: bold numbered questions ("1.What ...") become an accessible <details> accordion; anything else stays as it is
   - contact form: focuses the status message after a post, blocks double submits */
(function () {
  'use strict';
  var EMPTY_KEEP = 'img,picture,svg,video,iframe,embed,object,table,input,select,textarea,hr,canvas';
  var STOP = /\b(to|and|or|of|the|a|an|for|with|in|on|at|by|your|our|is|are)$/i;
  var QNUM = /^\s*(\d{1,2})\s*[.)]\s*/;
  /* whitespace incl. nbsp and zero-width characters (built from char codes, no escapes) */
  var SP = String.fromCharCode(32, 9, 10, 11, 12, 13, 160, 8203, 8204, 8205, 65279);
  var RX_SP = new RegExp('[' + SP + ']+', 'g');
  var RX_LEAD = new RegExp('^[' + SP + ']+');
  var RX_TRAIL = new RegExp('[' + SP + ']+$');
  function isWs(s) { return !String(s || '').replace(RX_SP, ''); }

  function txt(el) { return (el.textContent || '').replace(RX_SP, ' ').trim(); }
  function isBlank(el) { return !txt(el) && !el.querySelector(EMPTY_KEEP); }

  function hideEmpty(root) {
    var els = root.querySelectorAll('p,div,span,h1,h2,h3,h4,h5,h6,font');
    for (var i = els.length - 1; i >= 0; i--) {
      var el = els[i];
      if (el.closest('.pg-faq__q')) continue;
      if ((el.tagName === 'SPAN' || el.tagName === 'FONT') && el.querySelector('br')) continue;
      if (isBlank(el)) el.hidden = true;
    }
  }

  function wrapTables(root, label) {
    Array.prototype.forEach.call(root.querySelectorAll('table'), function (t) {
      if (t.parentNode && t.parentNode.classList && t.parentNode.classList.contains('pr-rte__scroll')) return;
      var w = document.createElement('div');
      w.className = 'pr-rte__scroll';
      w.tabIndex = 0;
      w.setAttribute('role', 'region');
      if (label) w.setAttribute('aria-label', label);
      t.parentNode.insertBefore(w, t);
      w.appendChild(t);
    });
  }

  function visibleNext(el) {
    var n = el.nextElementSibling;
    while (n && (n.hidden || /^(META|STYLE|SCRIPT|BR)$/.test(n.tagName))) n = n.nextElementSibling;
    return n;
  }

  function shortLine(el) {
    var t = el ? txt(el) : '';
    return !!t && t.length <= 70 && !/[.?!:;]$/.test(t);
  }

  function looksLikeTitle(el, allowStop) {
    var t = txt(el);
    if (t.length < 2 || t.length > 70) return false;
    if (t.split(' ').length > 10) return false;
    if (/[,;:!]$/.test(t) || (!allowStop && /\.$/.test(t))) return false;
    if (/[:@]|www\.|https?:/i.test(t)) return false;
    if (STOP.test(t.replace(/[.?]$/, ''))) return false;
    if (el.querySelector('a,img,table,iframe')) return false;
    var n = visibleNext(el);
    if (!(n && /^(P|UL|OL|DIV|TABLE)$/.test(n.tagName) && txt(n).length > 0)) return false;
    /* a run of short lines is a list, not a heading */
    if (n.tagName === 'P' && shortLine(n)) return false;
    return true;
  }

  /* trim leading/trailing spaces and nbsp inside a heading (presentation only) */
  function trimEdges(el) {
    var w = document.createTreeWalker(el, 4), nodes = [], n;
    while ((n = w.nextNode())) nodes.push(n);
    for (var i = 0; i < nodes.length; i++) { var v = nodes[i].nodeValue.replace(RX_LEAD, ''); nodes[i].nodeValue = v; if (v) break; }
    for (var j = nodes.length - 1; j >= 0; j--) { var u = nodes[j].nodeValue.replace(RX_TRAIL, ''); nodes[j].nodeValue = u; if (u) break; }
  }

  /* pasted content is sometimes wrapped in many nested divs: work on the innermost wrapper */
  function contentRoot(rte) {
    var r = rte, guard = 0;
    while (guard++ < 40) {
      var kids = Array.prototype.filter.call(r.children, function (c) { return !c.hidden && !/^(META|STYLE|SCRIPT|BR)$/.test(c.tagName); });
      if (kids.length === 1 && /^(DIV|SECTION|ARTICLE)$/.test(kids[0].tagName) && !questionOf(kids[0])) r = kids[0]; else break;
    }
    return r;
  }

  function smartHeadings(root) {
    var real = 0;
    Array.prototype.forEach.call(root.querySelectorAll('h1,h2,h3,h4,h5,h6'), function (h) { if (!h.hidden) real++; });
    if (real >= 2) return;
    Array.prototype.forEach.call(root.children, function (el) {
      if (el.hidden) return;
      var tag = el.tagName;
      var ok = false;
      if (tag === 'P' && looksLikeTitle(el, false)) ok = true;
      else if (tag === 'UL' && el.children.length === 1 && looksLikeTitle(el, true)) ok = true;
      if (!ok) return;
      el.classList.add('pr-rte__h');
      trimEdges(el);
      if (tag === 'P') { el.setAttribute('role', 'heading'); el.setAttribute('aria-level', '2'); }
      else { var li = el.children[0]; el.setAttribute('role', 'presentation'); li.setAttribute('role', 'heading'); li.setAttribute('aria-level', '2'); }
    });
  }

  function markCaps(root) {
    Array.prototype.forEach.call(root.querySelectorAll('h1,h2,h3,h4,h5,h6,.pr-rte__h'), function (h) {
      var t = txt(h);
      if (t.length > 3 && /[A-Z]/.test(t) && t === t.toUpperCase()) h.classList.add('is-caps');
    });
  }

  /* first meaningful child node of a block, skipping whitespace text and <br> */
  function firstMeaningful(block) {
    var n = block.firstChild;
    while (n && ((n.nodeType === 3 && isWs(n.nodeValue)) || (n.nodeType === 1 && (n.tagName === 'BR' || n.tagName === 'META')))) n = n.nextSibling;
    return n;
  }

  /* returns the question element when this block starts a numbered question */
  function questionOf(block) {
    if (/^H[2-6]$/.test(block.tagName) && QNUM.test(txt(block))) return block;
    var f = firstMeaningful(block);
    if (f && f.nodeType === 1 && /^(STRONG|B)$/.test(f.tagName) && QNUM.test(txt(f))) return f;
    if (f && f.nodeType === 1 && f.tagName === 'SPAN') {
      var g = firstMeaningful(f);
      if (g && g.nodeType === 1 && /^(STRONG|B)$/.test(g.tagName) && QNUM.test(txt(g))) return g;
    }
    return null;
  }

  function rte_of(el) { return el.closest('[data-pr-rte]') || el; }

  var faqSeq = 0;
  function buildFaq(root) {
    var blocks = Array.prototype.slice.call(root.children);
    var starts = blocks.filter(function (b) { return !b.hidden && questionOf(b); });
    if (starts.length < 2) return false;
    var list = document.createElement('div');
    list.className = 'pg-faq';
    var cur = null, n = 0, placed = false, uid = ++faqSeq;
    blocks.forEach(function (b) {
      var q = b.hidden ? null : questionOf(b);
      if (q) {
        if (!placed) { root.insertBefore(list, b); placed = true; }
        n++;
        var t = txt(q), m = t.match(QNUM), num = m ? m[1] : String(n), qt = t.replace(QNUM, '');
        var d = document.createElement('details');
        d.className = 'pg-faq__item';
        d.id = 'faq-' + num + (uid > 1 ? '-' + uid : '');
        var s = document.createElement('summary');
        s.className = 'pg-faq__q';
        s.innerHTML = '<span class="pg-faq__n" aria-hidden="true"></span><span class="pg-faq__t"></span><span class="pg-faq__sign" aria-hidden="true"></span>';
        s.children[0].textContent = num;
        s.children[1].textContent = qt;
        var sr = document.createElement('span');
        sr.className = 'ap-sr';
        sr.textContent = num + '. ';
        s.children[1].insertBefore(sr, s.children[1].firstChild);
        var a = document.createElement('div');
        a.className = 'pg-faq__a';
        d.appendChild(s); d.appendChild(a);
        list.appendChild(d);
        if (q === b) { b.parentNode.removeChild(b); }
        else {
          /* move everything after the question (inside this block) into the answer */
          var host = q.parentNode, after = [], x = q.nextSibling;
          while (x) { after.push(x); x = x.nextSibling; }
          while (after.length && ((after[0].nodeType === 3 && isWs(after[0].nodeValue)) || (after[0].nodeType === 1 && after[0].tagName === 'BR'))) after.shift().remove();
          if (host !== b) { var y = host.nextSibling; while (y) { after.push(y); y = y.nextSibling; } }
          var hasContent = after.some(function (node) { return node.nodeType === 1 ? node.tagName !== 'BR' : !isWs(node.nodeValue); });
          if (!hasContent) after.forEach(function (node) { node.remove(); });
          else { var p = document.createElement('p'); after.forEach(function (node) { p.appendChild(node); }); a.appendChild(p); }
          b.parentNode.removeChild(b);
        }
        cur = a;
      } else if (cur) {
        if (b.hidden) b.parentNode.removeChild(b);
        else cur.appendChild(b);
      } else if (!b.hidden) {
        b.classList.add('pg-faq__pre');
      }
    });
    Array.prototype.forEach.call(list.querySelectorAll('.pg-faq__a'), function (a) { if (isBlank(a)) { var d = a.parentNode; d.classList.add('is-empty'); } });
    rte_of(root).classList.add('is-faq');
    function openHash() {
      var h = (location.hash || '').slice(1);
      if (!h) return;
      var el = document.getElementById(h);
      if (el && el.classList.contains('pg-faq__item')) { el.open = true; el.scrollIntoView({ block: 'start' }); }
    }
    openHash();
    window.addEventListener('hashchange', openHash);
    return true;
  }

  function initForm(el) {
    var st = el.querySelector('[data-pr-form-status]');
    if (st) { try { st.focus({ preventScroll: false }); } catch (e) { st.focus(); } }
    Array.prototype.forEach.call(el.querySelectorAll('form[data-pr-cform]'), function (f) {
      f.addEventListener('submit', function () {
        var b = f.querySelector('[type="submit"]');
        if (b) setTimeout(function () { b.setAttribute('aria-busy', 'true'); }, 0);
      });
    });
  }

  function init(el) {
    var rte = el.querySelector('[data-pr-rte]');
    if (rte && !rte.hasAttribute('data-pr-done')) {
      rte.setAttribute('data-pr-done', '');
      var title = el.querySelector('.pg-title');
      hideEmpty(rte);
      wrapTables(rte, title ? txt(title) : '');
      var root = contentRoot(rte);
      var faq = rte.hasAttribute('data-pr-faq') && buildFaq(root);
      if (!faq && rte.hasAttribute('data-pr-headings')) smartHeadings(root);
      markCaps(rte);
    }
    initForm(el);
  }

  function boot() {
    if (window.PR && PR.sections && PR.sections.register) {
      PR.sections.register('pr-page', init);
      PR.sections.register('pr-contact', init);
    } else {
      var run = function () { Array.prototype.forEach.call(document.querySelectorAll('[data-pr-section="pr-page"],[data-pr-section="pr-contact"]'), init); };
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
    }
  }
  boot();
})();
